import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'

const styles = theme => ({
  button: {
    '&:hover': {
      backgroundColor: theme.palette.common.white,
      color: theme.palette.common.black
    }
  }
})

class RefreshButton extends React.Component {
  handleRefresh = () => {
    window.location.reload()
  }

  render () {
    const { classes, buttonText = 'Refresh' } = this.props // Default text if none provided

    return (
      <Button
        className={classes.button}
        color='inherit'
        size='small'
        onClick={this.handleRefresh}
        variant='outlined'
      >
        {buttonText}
      </Button>
    )
  }
}

const RefreshButtonComponent = withStyles(styles)(RefreshButton)

export { RefreshButtonComponent as RefreshButton }
